import {requestHelpers} from '../../../../../helpers';
import {updateTodoList} from '../../../../../actions/todo_list/todo_list';

export const actions = {
  SET_EDUCATION: "SET_EDUCATION",
  GENERAL_EDUCATION_REQUEST: "GENERAL_EDUCATION_REQUEST",
  GENERAL_EDUCATION_SUCCESS: "GENERAL_EDUCATION_SUCCESS",
  GENERAL_EDUCATION_ERROR: "GENERAL_EDUCATION_ERROR",
  DELETE_EDUCATION_SUCCESS: "DELETE_EDUCATION_SUCCESS"
};

export const setEducation = (profile) => {
  const educationWithPersonId = profile.education.map(education => Object.assign(education, {person_id: profile.id}));
  const noData = educationWithPersonId.length === 0;
  return {
    type: actions.SET_EDUCATION,
    personId: profile.id,
    body: educationWithPersonId,
    noData
  }
};

export const educationApiCall = (personId, payload, type, callbackToHOC) => {
  const requestType = type === 'CREATE' ? 'POST' : ( type === 'UPDATE' ? 'PUT' : 'DELETE' );
  const endpoint = type === 'CREATE' ? '' : ( payload.id ? `/${ payload.id }` : `/${ payload }`);
  return (dispatch) => {
    dispatch({
      type: actions.GENERAL_EDUCATION_REQUEST,
      isEducationFetching: true,
      isEducationError: false
    });

    const _payload = {...payload};

    if (requestType !== 'DELETE') {
      _payload.qualification_date = payload.i_still_study_here ? undefined :
        ( payload.end_year && payload.end_month ?
          `${ payload.end_year.value }-0${ payload.end_month.value }` : "");
    }

    requestHelpers
      .authenticatedPostRequest(`/profiles/${ personId }/education${endpoint}`, _payload, requestType)
      .then((response) => {
        callbackToHOC();
        payload.hasOwnProperty('id') ? _payload.id = _payload.id || response.data.id : payload;
        return dispatch({
          type: requestType === 'DELETE' ? actions.DELETE_EDUCATION_SUCCESS : actions.GENERAL_EDUCATION_SUCCESS,
          personId: personId,
          body: requestType === 'DELETE' ? payload : _payload,
          isEducationFetching: false,
          isEducationError: false
        })
      })
      .catch((error) => {
        callbackToHOC(error);
      })
    dispatch(updateTodoList(personId, 8));
  }
};


// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/education.js